export const upstreamKey = {
  SUPPLIER_NAME: 'name',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  MOBILE: 'mobile',
  EMAIL: 'email',
  PARTNER_TYPE: 'partnerType',
  ADDRESS: 'address',
  PINCODE: 'pincode',
  COUNTRY: 'country',
  STATE: 'state',
  CITY: 'city',
  ENV_CRITERIA: 'isEnvironmentalCriteria',
  SUSTAINABLE_SOURCING: 'isSustainableSourcing',
  PRODUCT_DATA: 'transportationData',
  FREQUENCY_TRANSPORT: 'frequencyOfTransportation',
  FREQUENCY_NUM: 'frequencyNumber',
  MODE: 'mode',
  CLASS_OF_TRAVEL: 'classOftravel',
  QUANTITY: 'quantity',
  QUANTITY_UNIT: 'quantityUnit',
  DISTANCE_TRAVELLED: 'distanceTravelled',
  DISTANCE_UNIT: 'distanceTravelledUnit',
  SUPPLIER: 'supplier',
  FACILITY: 'facility',
  COORDINATES: 'coordinates',
  TOTAL_EMISSIONS: 'totalEmissions',
  emissionVehicle: 'totalEmissions',
  emissionProperty: 'totalEmissions',
  LESSOR_NAME: 'assetLessorName',
  RENTED_FROM: 'rentedFrom',
  RENTED_TO: 'rentedTo',
  FLOOR_SPACE: 'floorSpace',
  KM_DRIVEN: 'vehicleKmDriven',
  supplierType: 'typeOfSupplier',
  goodsSupplied: 'goodsSupplied',
  capSupplied: 'capitalGoodsSupplied',
  rawSupplied: 'rawMaterialsSupplied',
  STATUS: 'status',
  COMMENT: 'comment'
};

export const upstreamLabel = {
  SUPPLIER_NAME: 'Supplier Name',
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  PARTNER_NAME: 'Partner Name',
  MOBILE: 'Mobile Number',
  EMAIL: 'Email ID',
  PARTNER_TYPE: 'Partner Type',
  SUPPLIER_TYPE: 'Supplier Type',
  ADDRESS: 'Address',
  PINCODE: 'Pincode',
  COUNTRY: 'Country',
  STATE: 'State',
  CITY: 'City',
  ENV_CRITERIA: 'Whether Supplier Screened Using Environmental Criteria',
  LIST_ENV_CRITERIA: 'Environmental Criteria',
  SUSTAINABLE_SOURCING: 'Sustainable Sourcing',
  PRODUCT_DATA: 'Transport Details',
  FREQUENCY_TRANSPORT: 'Frequency of Transportation',
  FREQUENCY_NUM: 'Frequency Number',
  MODE: 'Mode of Transport',
  CLASS_OF_TRAVEL: 'Class of travel',
  QUANTITY: 'Quantity',
  QUANTITY_UNIT: 'Quantity Unit',
  DISTANCE_TRAVELLED: 'Distance Travelled',
  DISTANCE_UNIT: 'Distance unit',
  SUPPLIER: 'Supplier',
  TOTAL_EMISSIONS: 'Total emissions',
  emissionVehicle: 'Total Fuel Emissions',
  LESSOR_NAME: 'Asset Lessor Name',
  RENTED_FROM: 'Rented From',
  RENTED_TO: 'Rented To',
  FLOOR_SPACE: 'Floor Space',
  KM_DRIVEN: 'Km Driven',
  supplierType: 'Supplier Type',
  goodsSupplied: 'Goods Supplied',
  capSupplied: 'Capital Goods Supplied',
  rawSupplied: 'Raw Material Supplied',
  STATUS_COMMENTS: 'Status & Comments',
  STATUS: 'Status',
  COMMENT: 'Comment'
};
